import vue from '../../main.js'
import store from '../../store'
import router from '../../router'
import data from './data.js'

export default {
  toURL(URL) {
    router.push(URL)
  },
  // 格式化时间
  formatTime(date) {
    const time = new Date(date)
    return this.formatDate(time * 1, 'yyyy-MM-dd hh:mm:ss')
  },
  formatTimeDate(date) {
    const time = new Date(date)
    return this.formatDate(time * 1, 'yyyy-MM-dd')
  },
  // 登录成功，当用户账号密码输入正确，或者通过别的方式登录成功时的一系列处理逻辑
  loginSuccess(token, userInfo, str) {
    if (token) {
      this.setStorage('token', token)
    }
    if (userInfo) {
      this.setStorage('userInfo', userInfo)
    }
    store.commit('SET_USERINFO', userInfo)

    if (str) {
      window.location = str
    } else {
      vue.$message.success('登录成功，正在为您跳转到首页...', 1)
      vue.axios.get('/biz/home/needDeal/count').then(async res => {
        // 查询未缴费弹框提示配置参数
        await vue.axios
          .get(`/biz/tips/getTipsParam`)
          .then(res => {
            if (res.success) {
              vue.$store.state.tipsObj = res.result
              localStorage.setItem('tipsObj', JSON.stringify(res.result))
            }
          })
          .catch(err => {
            console.log(err)
          })
        // 查询学生教务参数
        await vue.axios.get(`/biz/home/param`).then(res => {
          if (res.code === 200) {
            vue.$store.state.homeObj = res.result
            localStorage.setItem('homeObj', JSON.stringify(res.result))
          }
        })
        if (res.result) {
          router.replace('/')
        } else {
          router.replace('/todos/list')
        }
      })
    }
  },

  info() {
    const h = vue.$createElement
    vue.$info({
      title: '消息通知',
      content: h('div', {}, [h('p', '请到微信公众号完成身份认证!')]),
      onOk() {},
    })
  },

  // 获取微信code
  getWXcode() {
    return new Promise(function(resolve, reject) {
      uni.login({
        provider: 'weixin',
        success: loginRes => {
          if (loginRes.code) {
            resolve(loginRes.code)
          }
        },
      })
    })
  },
  setStorage(key, value, type) {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value)
    if (type === 'local') {
      localStorage.setItem(key, stringValue)
    } else if (type === 'session') {
      sessionStorage.setItem(key, stringValue)
    } else {
      localStorage.setItem(key, stringValue)
    }
  },
  getStorage(key, flag) {
    let storage = sessionStorage.getItem(key) || localStorage.getItem(key)
    if (flag === true) {
      storage = JSON.parse(storage)
    }
    return storage
  },
  getToken() {
    const token = this.getStorage('token')
    if (token) {
      return token
    }
    if (localStorage.getItem('isLoginByInter') === '1' || localStorage.getItem('isLoginByInter') === '2') {
      return
    }
    localStorage.clear()
    sessionStorage.clear()
    return false
  },
  // 将数字转化为大写数字（汉字）
  judgeNumberIndexIndex(index) {
    if (index !== 'undefined') {
      return data.numberIndex[index]
    }
    return false
  },

  /**
   * 时间格式化
   * @param value
   * @param fmt
   * @returns {*}
   */
  formatDate(value, fmt) {
    let regPos = /^\d+(\.\d+)?$/
    if (regPos.test(value)) {
      // 如果是数字
      let getDate = new Date(value)
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        S: getDate.getMilliseconds(),
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
      }
      return fmt
    } else {
      // TODO
      value = value.trim()
      return value.substr(0, fmt.length)
    }
  },

  /**
   * 日期转时间戳
   * @param {string} dateString 传递过来的日期字符串
   */
  format(dateString) {
    let date = new Date(dateString)
    var time2 = date.valueOf()
    return time2
  },

  /**
   * 字符串转DOM对象
   * @param {string} dateString 传递过来的html字符串
   */
  parseToDOM(str) {
    var div = document.createElement('div')
    if (typeof str === 'string') {
      div.innerHTML = str
    }
    return div.childNodes
  },

  /**
   * 判断提示应该是$message.error还是alert
   * @param {string} message 传递过来的需要展示的提示内容
   */
  judgeAlertOrMessage(message) {
    let currentRoutePath = vue.$route.path
    if (data.needAlertRoute.indexOf(currentRoutePath) === -1) {
      // if (currentRoutePath.indexOf('/infocollect') !== -1) {
      //   vue.$router.push('/personalcenters/infocollect')
      // }
      vue.$message.error(message, 3)
    } else {
      vue.$warning({
        title: '温馨提示',
        icon: 'smile',
        content: message,
        centered: true,
        okButtonProps: {
          style: { background: '#2caf7a', border: `1px solid #2caf7a` },
        },
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/common/js/common.js